export const parseHash = (baseSearchParams: URLSearchParams) => {
  const hash = baseSearchParams.get("hash");
  const decoded = atob(hash ?? "");
  const searchParams = new URLSearchParams(decoded);
  baseSearchParams.forEach((value, key) => {
    searchParams.append(key, value);
  });

  return searchParams;
};
